import { Button } from '@piplapps/pipl-ui';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import styles from './UploadUsersListContainer.module.less';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { sanitizeCsvData } from '../../../../Utils/CsvUtils';

const ValidateCSVModal = (props) => {
  const spinner = (
    <div className={styles.spinnerWrapper}>
      <div className={[styles.spinner, styles.scanSpinner].join(' ')}>
        <div />
        <div />
      </div>
    </div>
  );

  const { reportCsv } = props;

  const csvReportData = useMemo(() => sanitizeCsvData(reportCsv), [reportCsv]);

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{gettext('Upload user list')}</div>
      <div className={styles.paragraph}>{gettext('Step 2 - Validate the CSV information')}</div>
      {props.isLoading ? (
        spinner
      ) : (
        <>
          <div className={styles.text}>
            {!!props.validUsers && (
              <div>
                {props.validUsers}
                {gettext(` new user${props.validUsers > 1 ? 's' : ''} will be created. `)}
                {!!props.usersToBeSubscribed && (
                  <span>
                    {props.usersToBeSubscribed < props.validUsers ? props.usersToBeSubscribed : props.validUsers}
                    {gettext(
                      ' will be assigned to a seat. When there are no open seats, the users will be created without them.',
                    )}
                  </span>
                )}
              </div>
            )}
            {!!props.existingUsers && (
              <div className={styles.section}>
                {props.existingUsers}
                {gettext(
                  ' users already exist in your organization. Their information will be updated according to the file.',
                )}
              </div>
            )}
            {!!props.invalidUsers && (
              <div className={[styles.section, styles.red].join(' ')}>
                {props.invalidUsers}
                {gettext(' users will not be created since they have wrong or missing information.')}
              </div>
            )}
          </div>
          <div className={styles.buttons}>
            <div className={styles.leftButton}>
              <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_DOWNLOAD_REPORT}>
                <CSVLink data={csvReportData} filename="users-list-report.csv">
                  <Button buttonClass="secondary-blue" text={gettext('Download report')} />
                </CSVLink>
              </AnalyticsHandler>
            </div>

            <div className={styles.rightButton}>
              <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_SELECT_FILE}>
                <Button
                  buttonClass="secondary-blue"
                  text={gettext('Upload new CSV')}
                  onClick={() => props.switchStageToUpload()}
                />
              </AnalyticsHandler>
            </div>
          </div>
          <div className={styles.separator} />
          <div className={styles.paragraph}>{gettext('Step 3 - Add new users')}</div>
          <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_SUBMIT_FILE}>
            <Button
              buttonClass="primary-blue"
              text={gettext('Continue and add users')}
              onClick={() => {
                props.addUsersFromCsv();
              }}
            />
          </AnalyticsHandler>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    uploadUsersListStage: UsersSelectors.uploadUsersListStageSelector(state),
    isLoading: UsersSelectors.isLoadingUploadingUsersSelector(state),
    validUsers: UsersSelectors.validUsersInUploadSelector(state),
    existingUsers: UsersSelectors.existingUsersInUploadSelector(state),
    invalidUsers: UsersSelectors.invalidUsersInUploadSelector(state),
    reportCsv: UsersSelectors.reportListSelector(state),
    usersToBeSubscribed: UsersSelectors.usersToBeSubscribedSelector(state),
  };
};

const mapDispatchToProps = {
  clickGetStarted: UsersActions.clickGetStartedUploadUserList,
  validateCsvFile: UsersActions.validateCsvFile,
  switchStageToUpload: UsersActions.switchStageToUpload,
  addUsersFromCsv: UsersActions.addUsersFromCsv,
};

ValidateCSVModal.propTypes = {
  switchStageToUpload: PropTypes.func,
  validUsers: PropTypes.number,
  existingUsers: PropTypes.number,
  invalidUsers: PropTypes.number,
  isLoading: PropTypes.bool,
  reportCsv: PropTypes.array,
  usersToBeSubscribed: PropTypes.number,
  addUsersFromCsv: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateCSVModal);
